module.exports = __webpack_public_path__ + "media/images/application2/AppNav__panel__actions__a--session-01acf7a85d2a2769cafeaa9d44efdd3e.png";